import React, { FC } from 'react';
import classNames from 'classnames';

import { IPropsTitle } from './model';
import './Title.scss';

const Title: FC<IPropsTitle> = ({ dataTestAttr, children, className, Tag = 'h2' }) => (
  <Tag
    data-test={dataTestAttr}
    className={classNames('header-title', {
      [className || '']: className,
    })}
  >
    {children}
  </Tag>
);
export default Title;
